// LanguageProvider.jsx
import React, { createContext, useState, useContext } from "react";
import ja from "./locales/ja.json"; // 日本語の翻訳データ
import en from "./locales/en.json"; // 英語の翻訳データ

// 言語コンテキストを作成
const LanguageContext = createContext();

// 言語リソース（翻訳データ）
const languageResources = {
  ja: ja,
  en: en,
};

// LanguageProviderコンポーネント
export const LanguageProvider = ({ children }) => {
  const [language, setLanguage] = useState("ja"); // デフォルトは日本語

  const changeLanguage = (lang) => {
    setLanguage(lang);
  };

  // 翻訳関数
  const translate = (key) => {
    const keys = key.split("."); // ドットで分割されたキーを扱う
    let translation = languageResources[language];

    // 深いネストがあっても対応できるように再帰的に取得
    for (let i = 0; i < keys.length; i++) {
      translation = translation[keys[i]];
      if (translation === undefined) {
        return key; // キーが存在しない場合はそのまま返す
      }
    }

    return translation;
  };

  return (
    <LanguageContext.Provider value={{ language, changeLanguage, translate }}>
      {children}
    </LanguageContext.Provider>
  );
};

// useLanguageカスタムフック
export const useLanguage = () => {
  return useContext(LanguageContext);
};
